import { useEffect, useState } from 'react'

export const defaultPageTitle = 'DopaGE Overdose Prevention'
export const pageTitleSuffix = ' | DopaGE Portal'

interface PageTitleProps {
  title: string
  addScreenReaderH1?: boolean
}

/** Sets the page title and the main screen reader only H1 tag.
 *  Reverts to the `defaultPageTitle` after the component is unmounted.
 */
const PageTitle: React.FC<PageTitleProps> = ({ title = defaultPageTitle, addScreenReaderH1 = true }) => {
  const [pageTitle, setPageTitle] = useState<string>(defaultPageTitle)
  const [ariaLabel, setAriaLabel] = useState<string>(defaultPageTitle)

  useEffect(() => {
    const fullPageTitle = `${title}${pageTitleSuffix}`

    setAriaLabel(title)
    setPageTitle(fullPageTitle)
    document.title = fullPageTitle

    return () => {
      setAriaLabel(defaultPageTitle)
      setPageTitle(defaultPageTitle)
      document.title = defaultPageTitle
    }
  }, [title])

  return (
    <div className='absolute top-0 left-0 w-0 h-0 overflow-hidden'>
      <title>{pageTitle}</title>
      {addScreenReaderH1 && (
        <h1 className='sr-only' aria-label={ariaLabel}>{ariaLabel}</h1>
      )}
    </div>
  )
}

export default PageTitle
